export enum CompanyTypeEnum {
  Installation,
  Teknikkonsult,
  Industri,
}
